import useCurrentResourceCentre from "./useCurrentResourceCentre";
import { IShift } from "../interfaces/ShiftInterface";

const useCurrentResourceCentreShifts = (): Array<IShift> => {
  const currentRc = useCurrentResourceCentre();
  const shifts = currentRc?.shifts || [];

  if (shifts.length === 0) {
    return [];
  }

  return shifts;
};

export default useCurrentResourceCentreShifts;
